import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    ClientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    eventextra1: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please provide an event date' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide a type of event' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please provide a selection' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company:',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Preferred Contact Method?:',
            options:[
              {label: 'Email' , value: 'Email'},
              {label: 'Phone' , value: 'Phone'},
            ],
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options:[
              {label: 'Meeting' , value: 'Meeting'},
              {label: 'Fundraiser' , value: 'Fundraiser'},
              {label: 'Social Celebration' , value: 'Social Celebration'},
              {label: 'Wedding Reception' , value: 'Wedding Reception'},
              {label: 'Wedding Ceremony' , value: 'Wedding Ceremony'},
              {label: 'Group Tour' , value: 'Group Tour'},
              {label: 'Holiday Party' , value: 'Holiday Party'},
              {label: 'Entertaining' , value: 'Entertaining'},
              {label: 'Other' , value: 'Other'},

            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:*',
            options:[
              {label: 'Inbound Call Email' , value: 'Inbound Call Email'},
              {label: 'Fearless Website Inquiry' , value: 'Fearless Website Inquiry'},
              {label: 'Internet Inquiry' , value: 'Internet Inquiry'},
              {label: 'CVB' , value: 'CVB'},
              {label: 'Outbound Call' , value: 'Outbound Call'},
              {label: 'Referral' , value: 'Referral'},
              {label: 'Repeat Customer' , value: 'Repeat Customer'},
              {label: 'Event' , value: 'Event'},
              {label: 'Walk-in' , value: 'Walk-in'},
              {label: 'Other' , value: 'Other'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Tuckers Tavern Contact Form',
    formId: '702',
    clientKey: '43B6D840-F218-456C-A276-1F978A9D2B22',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/tuckerstavern/form_structure.js